import { AdminTitle } from "../../../../store/reducers/site";
import { useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { shopImageUpload } from "../../../../store/actions/shopAction";
import Divider from '@mui/material/Divider' ;
import TextField from '@mui/material/TextField';
import {getUserData} from "../../../../utils/tools";



const ImageUpload=()=>{
    let { articleId } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading,setLoading] = useState(true);
    const news1 = useSelector(state=>state.news);
    const [file, setFile] = useState();
  const [uploadedFile, setUploadedFile] = useState();
  const [error, setError] = useState();
  let imgUrl='/dashboard/items/imageupload/'+articleId;
  

  

    function handleChange(event) {
        setFile(event.target.files[0]);
      }

        function handleSubmit(event) {
            event.preventDefault();
            let myArray = articleId.split("_");
            let id1= myArray[0];
            
          
           
            const formData = new FormData();
            formData.append('file', file);
            formData.append('applicationNo',id1);
            formData.append('userID',getUserData().userId);

            formData.append('title',event.target.title.value);
            formData.append('priorty',1);

       
		
		
		

           
            dispatch(shopImageUpload(formData))
        .unwrap()
        .then(()=>{
            //navigate(imgUrl)
            window.location.reload();
        })
        
          }
      
   
    return(
            <>
            <AdminTitle title=" Upload Image"/>
            <div className="App">
        <form className='mt-3 news_form'  onSubmit={handleSubmit}>
        <div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="title"
                    label="Image Title"
                    variant="outlined"
                  

                  
                   
                />
                </div>
               
        <div className='form-group'>
          <input type="file" onChange={handleChange}/>
          </div>
          <Divider className='mt-3 mb-3'/>
          

          
          <Button
                    variant='contained'
                    color="primary"
                    type="submit"
                >
                    Upload
                </Button>
        </form>
        {uploadedFile && <img src={uploadedFile} alt="Uploaded content"/>}
        {error && <p>Error uploading file: {error.message}</p>}
    </div>
    
            </>

            
    )
}
export default ImageUpload;